export default {
  data() {
    return {
      document_width: 0,
      breakpoints: {
        hd_plus: 2040,
        hd: 1920,
        desktop: 1440,
        laptop: 1366,
        laptop_small: 1280,
        max_content: 1060,
        tablet_wide: 960,
        tablet: 720,
        mobile_wide: 640,
        mobile_mid: 480,
        mobile: 360,
      },
    };
  },
  computed: {
    isHdPlus() {
      return this.document_width >= this.breakpoints.hd_plus;
    },
    isHdPlusMax() {
      return this.document_width < this.breakpoints.hd_plus;
    },
    isHd() {
      return this.document_width >= this.breakpoints.hd;
    },
    isHdMax() {
      return this.document_width < this.breakpoints.hd;
    },
    isDesktop() {
      return this.document_width >= this.breakpoints.desktop;
    },
    isDesktopMax() {
      return this.document_width < this.breakpoints.desktop;
    },
    isLaptop() {
      return this.document_width >= this.breakpoints.laptop;
    },
    isLaptopMax() {
      return this.document_width < this.breakpoints.laptop;
    },
    isLaptopSmall() {
      return this.document_width >= this.breakpoints.laptop_small;
    },
    isLaptopSmallMax() {
      return this.document_width < this.breakpoints.laptop_small;
    },
    isMaxContent() {
      return this.document_width >= this.breakpoints.max_content;
    },
    isMaxContentMax() {
      return this.document_width < this.breakpoints.max_content;
    },
    isTabletWide() {
      return this.document_width >= this.breakpoints.tablet_wide;
    },
    isTabletWideMax() {
      return this.document_width < this.breakpoints.tablet_wide;
    },
    isTablet() {
      return this.document_width >= this.breakpoints.tablet;
    },
    isTabletMax() {
      return this.document_width < this.breakpoints.tablet;
    },
    isMobileWide() {
      return this.document_width >= this.breakpoints.mobile_wide;
    },
    isMobileWideMax() {
      return this.document_width < this.breakpoints.mobile_wide;
    },
    isMobileMid() {
      return this.document_width >= this.breakpoints.mobile_mid;
    },
    isMobileMidMax() {
      return this.document_width < this.breakpoints.mobile_mid;
    },
    isMobile() {
      return this.document_width >= this.breakpoints.mobile;
    },
    isMobileMax() {
      return this.document_width < this.breakpoints.mobile;
    },
  },
  methods: {
    checkDocumentWidth() {
      this.document_width = window.innerWidth;
    },
  },
  mounted() {
    this.checkDocumentWidth();
    window.addEventListener("resize", this.checkDocumentWidth);
  },
};
